<template>
  <div class="paper-example">
    <h1>2019届湘教版九年级数学下册单元测试(二)　圆(A卷)</h1>
    <div class="paper-body">
      <question-box v-for="(question,index) in questions" :question="question" :key="index"></question-box>
    </div>
  </div>
</template>
<script type="text/babel">

  import questionBox from '../../../../../components/question/question-box.vue';

  export default {
    components: {
      questionBox
    },
    data: function() {
      return {
        questions:[
          {
            "id": 16528023,
            "stem": "<p style='line-height: 24px;'><span style=\"font-family: 宋体;\" >如图所示，四边形</span><span style=\"font-family: Times New Roman;\" >ABCD</span><span style=\"font-family: 宋体;\" >内接于⊙</span><span style=\"font-family: Times New Roman;\" >O，F</span><span style=\"font-family: 宋体;\" >是</span><math><mrow><mover accent=\"true\"><mrow><mi>C</mi><mi>D</mi></mrow><mo stretchy=\"true\">⌢</mo></mover></mrow></math><span style=\"font-family: 宋体;\" >上一点，且</span><math><mrow><mover accent=\"true\"><mrow><mi>D</mi><mi>F</mi></mrow><mo stretchy=\"true\">⌢</mo></mover><mo>=</mo><mover accent=\"true\"><mrow><mi>B</mi><mi>C</mi></mrow><mo stretchy=\"true\">⌢</mo></mover></mrow></math><span style=\"font-family: 宋体;\" >，连接</span><span style=\"font-family: Times New Roman;\" >CF</span><span style=\"font-family: 宋体;\" >并延长交</span><span style=\"font-family: Times New Roman;\" >AD</span><span style=\"font-family: 宋体;\" >的延长线于点</span><span style=\"font-family: Times New Roman;\" >E</span><span style=\"font-family: 宋体;\" >，连接</span><span style=\"font-family: Times New Roman;\" >AC.</span><span style=\"font-family: 宋体;\" >若∠</span><span style=\"font-family: Times New Roman;\" >ABC＝105°，</span><span style=\"font-family: 宋体;\" >∠</span><span style=\"font-family: Times New Roman;\" >BAC＝25°</span><span style=\"font-family: 宋体;\" >，则∠</span><span style=\"font-family: Times New Roman;\" >E</span><span style=\"font-family: 宋体;\" >的度数为</span><span style=\"font-family: Times New Roman;\" >(    )</span></p><p style='line-height: 24px;'><span style=\"font-family: Times New Roman;\" > </span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/2/2023282421145600/2023821247488000/STEM/e937729971f14230ad0ed8d608374cd4.png\" width=\"126\" height=\"102\" /></p>",
            "options": {
              "A": "<span style=\"\" >45°</span>",
              "B": "<span style=\"\" >50°</span>",
              "C": "<span style=\"\" >55°</span>",
              "D": "<span style=\"\" >60°</span>"
            },
            "difficult": {
              "id": 2,
              "name": "较易"
            },
            "type": {
              "id": 1101,
              "name": "单选题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T00:03:44",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 5763,
                "name": "8 圆内接正多边形",
                "pathIds": "5754,5763",
                "textbookId": 1354
              }
            ],
            "knowledgePoints": [
              {
                "id": 4555,
                "name": "已知圆内接四边形求角度",
                "pathIds": "4030,4474,4507,4554,4555",
                "subjectId": 11
              },
              {
                "id": 4554,
                "name": "圆内接四边形",
                "pathIds": "4030,4474,4507,4554",
                "subjectId": 11
              }
            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >试题分析：先根据圆内接四边形的性质求出∠ADC=180°﹣∠ABC=180°﹣105°=75°，再由圆周角定理得出∠DCE=∠BAC=25°，根据三角形外角的性质即可得出∠E=∠ADC﹣∠DCE=75°﹣25°=50°．</span><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >故选B．</span></p></span>"
          },
          {
            "id": 16668793,
            "stem": "<p style=''>如图所示，AB是⊙O的直径，OD⊥弦BC于点F，且交⊙O于点E，若∠AEC=∠ODB．</p><p style=''><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2015/7/9/1573867384201216/1573867390590976/STEM/852e51affde741f88a49f3fefd9c2ef2.png\" /></p><p style=''>（1）判断直线BD和⊙O的位置关系，并给出证明；</p><p style=''>（2）当AB=10，BC=8时，求BD的长．</p>",
            "options": null,
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 1103,
              "name": "解答题",
              "isSelectType": false
            },
            "updateTime": "2018-08-28T23:28:16",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "<span class=\"qml-an-sq\"><span class=\"qml-an\"><span style=\"\" >（1）答：BD和⊙O相切.</span><p style=''>证明：∵OD⊥BC,</p><p style=''>∴∠OFB=∠BFD =90°, </p><p style=''>∴∠D+∠3=90°. </p><p style=''>∵∠4=∠D=∠2,　　　　　……………………………1分</p><p style=''>∴∠2+∠3=90°,</p><p style=''>∴∠OBD=90°,</p><p style=''>即OB⊥BD.</p><p style=''>∵点B在⊙O上，</p><p style=''>∴BD和⊙O相切. ……………………………2分</p><p style=''> (2) ∵OD⊥BC,BC=8,</p><p style=''>∴BF=\"FC=4.  \" ……………………………3分</p><p style=''>∵  AB=10,</p><p style=''>∴OB=OA=5.</p><p style=''>在Rt△OFB中, ∠OFB =90°,</p><p style=''>∵OB=5,BF=4,</p><p style=''>∴OF=\"3.             \" ……………………………4分</p><p style=''><span style=\"\" >∴tan∠1=</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2011/5/9/1573210041769984/1573210111647744/ANSWER/545970f1b1d64bf684ba8ed812f59006.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2011-05/09/d47f141e-79b9-4b07-92cf-b0d3815d74ec/resource.files/imaged47f141e-79b9-4b07-92cf-b0d3815d74ec101.wmf\" /><span style=\"\" >.</span></p><p style=''>在Rt△OBD中, ∠OBD =90°,</p><p style=''><span style=\"\" >∵tan∠1=</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2011/5/9/1573210041769984/1573210111647744/ANSWER/80d6d327a4c64ff299c8dab89fc423de.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2011-05/09/d47f141e-79b9-4b07-92cf-b0d3815d74ec/resource.files/imaged47f141e-79b9-4b07-92cf-b0d3815d74ec102.wmf\" /><span style=\"\" >, OB=5,</span></p><p style=''><span style=\"\" >∴</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2011/5/9/1573210041769984/1573210111647744/ANSWER/473109274d9b41cfae09f15d2fa628db.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2011-05/09/d47f141e-79b9-4b07-92cf-b0d3815d74ec/resource.files/imaged47f141e-79b9-4b07-92cf-b0d3815d74ec103.wmf\" /><span style=\"\" >. …………………………… 5分</span></p></span></span>",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：（1）因为同弧所对的圆周角相等，所以有∠AEC=∠ABC，又∠AEC=∠ODB，所以∠ABC=∠ODB，OD⊥弦BC，即∠ABC+∠BOD=90°，则有∠ODB+∠BOD=90°，即BD垂直于AB，所以BD为切线．</span><p style=''>（2）连接AC，由于AB为直径，所以AC和BC垂直，又由（1）知∠ABC=∠ODB，所以有△ACB∽△OBD，而AC可由勾股定理求出，所以根据对应线段成比例求出BD．</p><p style=''>试题解析：（1）答：BD和⊙O相切．</p><p style=''>证明：∵OD⊥BC,</p><p style=''>∴∠OFB=∠BFD=90°,</p><p style=''>∴∠D+∠3=90°．</p><p style=''>∵∠4=∠D=∠2,</p><p style=''>∴∠2+∠3=90°,</p><p style=''>∴∠OBD=90°,</p><p style=''>即OB⊥BD．</p><p style=''>∵点B在⊙O上，</p><p style=''>∴BD和⊙O相切．</p><p style=''>（2）∵OD⊥BC,BC=8,</p><p style=''>∴BF=\"FC=4\" </p><p style=''>∵AB=10,</p><p style=''>∴OB=OA=5．</p><p style=''>在Rt△OFB中, ∠OFB =90°,</p><p style=''>∵OB=5,BF=4,</p><p style=''>∴OF=3．</p><p style=''><span style=\"\" >∴tan∠1=</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2015/7/9/1573867384201216/1573867390590976/EXPLANATION/fbe6b2e3e154403393ac5a53c3e77917.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2015-07/09/6d704b8c-0eb7-474c-aeb7-9a164c4f2a93/resource.files/image6d704b8c-0eb7-474c-aeb7-9a164c4f2a93121.wmf\" /><span style=\"\" >．</span></p><p style=''>在Rt△OBD中, ∠OBD =90°,</p><p style=''><span style=\"\" >∵tan∠1=</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2015/7/9/1573867384201216/1573867390590976/EXPLANATION/47269459a06f4c9babafd9292556dc1a.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2015-07/09/6d704b8c-0eb7-474c-aeb7-9a164c4f2a93/resource.files/image6d704b8c-0eb7-474c-aeb7-9a164c4f2a93122.wmf\" /><span style=\"\" >, OB=5,</span></p><p style=''><span style=\"\" >∴</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2015/7/9/1573867384201216/1573867390590976/EXPLANATION/8e650cb3a7db4674bd6578c8d527f560.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2015-07/09/6d704b8c-0eb7-474c-aeb7-9a164c4f2a93/resource.files/image6d704b8c-0eb7-474c-aeb7-9a164c4f2a93120.wmf\" /><span style=\"\" >．</span></p><p style=''><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2015/7/9/1573867384201216/1573867390590976/EXPLANATION/bfd8f133700b4a21926acb19cb8aa123.png\" /></p><p style=''>考点：1．曲线的判定；2．勾股定理和圆周角定理；3．相似三角形的判定与性质．</p></span>"
          },
          {
            "id": 16757294,
            "stem": "<p style='line-height: 24px;'><span style=\"font-family: 宋体;\" >如图，在⊙</span><span style=\"font-family: Times New Roman;\" >O</span><span style=\"font-family: 宋体;\" >中，</span><math><mrow><mover accent=\"true\"><mrow><mi>A</mi><mi>B</mi></mrow><mo stretchy=\"true\">⌢</mo></mover><mo>=</mo><mover accent=\"true\"><mrow><mi>A</mi><mi>C</mi></mrow><mo stretchy=\"true\">⌢</mo></mover></mrow></math><span style=\"font-family: Times New Roman;\" >，</span><span style=\"font-family: 宋体;\" >∠</span><span style=\"font-family: Times New Roman;\" >AOB＝40°</span><span style=\"font-family: 宋体;\" >，则∠</span><span style=\"font-family: Times New Roman;\" >ADC</span><span style=\"font-family: 宋体;\" >的度数是</span><span style=\"font-family: Times New Roman;\" >(      )</span></p><p style='line-height: 24px;'><span style=\"font-family: Times New Roman;\" > </span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/2/2023282421145600/2023821247455232/STEM/78b009a8aee3458faaef45edbe4af58d.png\" width=\"89\" height=\"98\" /></p>",
            "options": {
              "A": "<span style=\"\" >40°</span>",
              "B": "<span style=\"\" >30°</span>",
              "C": "<span style=\"\" >20°</span>",
              "D": "<span style=\"\" >15°</span>"
            },
            "difficult": {
              "id": 5,
              "name": "困难"
            },
            "type": {
              "id": 1101,
              "name": "单选题",
              "isSelectType": true
            },
            "updateTime": "2018-08-25T23:44:16",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [
              {
                "id": 4474,
                "name": "圆",
                "pathIds": "4030,4474",
                "subjectId": 11
              }
            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >先由圆心角、弧、弦的关系求出∠AOC=∠AOB=50°，再由圆周角定理即可得出结论．</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >解：∵在⊙O中，</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2017/8/21/1756691741089792/1757419352727552/EXPLANATION/a4ade19746d54973989e2a8f86fdf6ef.png\" width=\"19\" height=\"16\" /><span style=\"font-family: 宋体;\" > =</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2017/8/21/1756691741089792/1757419352727552/EXPLANATION/94f82b255d724832a603ed951fbca93f.png\" width=\"19\" height=\"16\" /><span style=\"font-family: 宋体;\" > ，</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >∴∠AOC=∠AOB，</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >∵∠AOB=40°，</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >∴∠AOC=40°，</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >∴∠ADC= ∠AOC=20°，</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >故选C．</span></p></span>"
          },
          {
            "id": 17146224,
            "stem": "<p style='line-height: 24px;'><span style=\"font-family: 宋体;\" >如图，</span><span style=\"font-family: Times New Roman;\" >AB</span><span style=\"font-family: 宋体;\" >是⊙</span><span style=\"font-family: Times New Roman;\" >O</span><span style=\"font-family: 宋体;\" >的直径，弦</span><span style=\"font-family: Times New Roman;\" >CD</span><span style=\"font-family: 宋体;\" >⊥</span><span style=\"font-family: Times New Roman;\" >AB</span><span style=\"font-family: 宋体;\" >，垂足为</span><span style=\"font-family: Times New Roman;\" >P.</span><span style=\"font-family: 宋体;\" >若</span><span style=\"font-family: Times New Roman;\" >CD＝8，OP＝3</span><span style=\"font-family: 宋体;\" >，则⊙</span><span style=\"font-family: Times New Roman;\" >O</span><span style=\"font-family: 宋体;\" >的半径为</span><span style=\"font-family: Times New Roman;\" >(    ) </span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/2/2023282421145600/2023821247463424/STEM/8724909d9fee480abd6097287a576829.png\" width=\"108\" height=\"90\" /></p>",
            "options": {
              "A": "10",
              "B": "8",
              "C": "5",
              "D": "3"
            },
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 1101,
              "name": "单选题",
              "isSelectType": true
            },
            "updateTime": "2018-09-11T00:28:46",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：连接OC，</span><p style=''>∵CD⊥AB，CD=8，</p><p style=''><span style=\"\" >∴PC=</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2016/12/6/1579031543570432/1579031543750656/EXPLANATION/78d5e228f24c4de78b32434cd5b680f3.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2016-12/02/84538224-e571-4f70-9f78-c950a353718b/resource.files/image84538224-e571-4f70-9f78-c950a353718b7.wmf\" /><span style=\"\" >CD=</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2016/12/6/1579031543570432/1579031543750656/EXPLANATION/78d5e228f24c4de78b32434cd5b680f3.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2016-12/02/84538224-e571-4f70-9f78-c950a353718b/resource.files/image84538224-e571-4f70-9f78-c950a353718b7.wmf\" /><span style=\"\" >×8=4，</span></p><p style=''>在Rt△OCP中，</p><p style=''>∵PC=4，OP=3，</p><p style=''><span style=\"\" >∴OC=</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2016/12/6/1579031543570432/1579031543750656/EXPLANATION/e175a57014f749ccbb6d955f579d36ec.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2016-12/02/84538224-e571-4f70-9f78-c950a353718b/resource.files/image84538224-e571-4f70-9f78-c950a353718b9.wmf\" /><span style=\"\" >=</span><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2016/12/6/1579031543570432/1579031543750656/EXPLANATION/75798d04aa8948c886fe8ca4f06a5b78.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2016-12/02/84538224-e571-4f70-9f78-c950a353718b/resource.files/image84538224-e571-4f70-9f78-c950a353718b10.wmf\" /><span style=\"\" >=5．</span></p><p style=''>故选C．</p><p style=''><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2016/12/6/1579031543570432/1579031543750656/EXPLANATION/0c9e74e771a44165891a51a15e67fd05.png\" /></p><p style=''>考点：垂径定理；勾股定理．</p></span>"
          },
          {
            "id": 17162467,
            "stem": "<p style='line-height: 24px;'><span style=\"font-family: 宋体;\" >⊙</span><span style=\"font-family: Times New Roman;\" >O</span><span style=\"font-family: 宋体;\" >的半径为</span><span style=\"font-family: Times New Roman;\" >2</span><span style=\"font-family: 宋体;\" >，弦</span><span style=\"font-family: Times New Roman;\" >BC＝2</span><math><mrow><msqrt><mn>3</mn></msqrt></mrow></math><span style=\"font-family: 宋体;\" >，点</span><span style=\"font-family: Times New Roman;\" >A</span><span style=\"font-family: 宋体;\" >是⊙</span><span style=\"font-family: Times New Roman;\" >O</span><span style=\"font-family: 宋体;\" >上一点，且</span><span style=\"font-family: Times New Roman;\" >AB＝AC</span><span style=\"font-family: 宋体;\" >，直线</span><span style=\"font-family: Times New Roman;\" >AO</span><span style=\"font-family: 宋体;\" >与</span><span style=\"font-family: Times New Roman;\" >BC</span><span style=\"font-family: 宋体;\" >交于点</span><span style=\"font-family: Times New Roman;\" >D</span><span style=\"font-family: 宋体;\" >，则</span><span style=\"font-family: Times New Roman;\" >AD</span><span style=\"font-family: 宋体;\" >的长为</span><span class=\"qml-bk\"  index=\"1\" size=\"5\" type=\"underline\" style=\"text-decoration:underline\" >　　　　　</span><span style=\"font-family: Times New Roman;\" >．</span></p>",
            "options": null,
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 1102,
              "name": "填空题",
              "isSelectType": false
            },
            "updateTime": "2018-09-11T00:28:46",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "<span class=\"qml-an-sq\"><span class=\"qml-an\"><span style=\"font-family: Times New Roman;\" >3</span><span style=\"font-family: 宋体;\" >或</span><span style=\"font-family: Times New Roman;\" >1</span></span></span>",
            "analysis": "<span class=\"qml-general\"><span style=\"\">试题分析：如图所示：</span><p style=\"\"><span style=\"\">∵⊙O的半径为2，弦BC=2</span><img src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2014/9/26/1573750491136000/1573750496976896/EXPLANATION/bff8ace4c4c34200bf5961a8bf941624.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2014-09/26/4f92314e-fc03-467a-83ad-78f29bc03723/resource.files/image4f92314e-fc03-467a-83ad-78f29bc0372327.wmf\"><span style=\"\">，点A是⊙O上一点，且AB=AC，</span></p><p style=\"\">∴AD⊥BC，</p><p style=\"\"><span style=\"\">∴BD=BC=</span><img src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2014/9/26/1573750491136000/1573750496976896/EXPLANATION/bff8ace4c4c34200bf5961a8bf941624.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2014-09/26/4f92314e-fc03-467a-83ad-78f29bc03723/resource.files/image4f92314e-fc03-467a-83ad-78f29bc0372327.wmf\"><span style=\"\">，</span></p><p style=\"\">在Rt△OBD中，</p><p style=\"\"><span style=\"\">∵BD</span><sup>2</sup><span style=\"\">+OD</span><sup>2</sup><span style=\"\">=OB</span><sup>2</sup><span style=\"\">，即（</span><img src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2014/9/26/1573750491136000/1573750496976896/EXPLANATION/bff8ace4c4c34200bf5961a8bf941624.png\" wmf=\"http://static.zujuan.xkw.com/Upload/2014-09/26/4f92314e-fc03-467a-83ad-78f29bc03723/resource.files/image4f92314e-fc03-467a-83ad-78f29bc0372327.wmf\"><span style=\"\">）</span><sup>2</sup><span style=\"\">+OD</span><sup>2</sup><span style=\"\">=2</span><sup>2</sup><span style=\"\">，解得OD=1，</span></p><p style=\"\">∴当如图1所示时，AD=OA﹣OD=2﹣1=1；</p><p style=\"\">当如图2所示时，AD=OA+OD=2+1=3．</p><p style=\"\">故答案为：1或3．</p><p style=\"\"><img src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2014/9/26/1573750491136000/1573750496976896/EXPLANATION/6e871294efca4a24892a83e4d3a4141d.png\"></p><p style=\"\">考点：1、垂径定理；2、勾股定理．</p><p style=\"line-height: 24px;text-align: left;\"></p></span>"
          },
          {
            "id": 17206706,
            "stem": "<p style='line-height: 24px;'><span style=\"font-family: 宋体;\" >如图，菱形</span><span style=\"font-family: Times New Roman;\" >ABCD</span><span style=\"font-family: 宋体;\" >的对角线</span><span style=\"font-family: Times New Roman;\" >AC，BD</span><span style=\"font-family: 宋体;\" >相交于点</span><span style=\"font-family: Times New Roman;\" >O，AC＝8，BD＝6</span><span style=\"font-family: 宋体;\" >，以</span><span style=\"font-family: Times New Roman;\" >AB</span><span style=\"font-family: 宋体;\" >为直径作一个半圆，则图中阴影部分的面积为</span><span style=\"font-family: Times New Roman;\" >(     ) </span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/2/2023282421145600/2023821247504384/STEM/d05cf72d9f534272ba4d82599decaa9c.png\" width=\"142\" height=\"76\" /></p>",
            "options": {
              "A": "25π-6",
              "B": "<math><mrow><mfrac><mrow><mn>25</mn></mrow><mn>2</mn></mfrac></mrow></math><span style=\"\" >π-6</span>",
              "C": "<math><mrow><mfrac><mrow><mn>25</mn></mrow><mn>6</mn></mfrac></mrow></math><span style=\"\" >π-6</span>",
              "D": "<math><mrow><mfrac><mrow><mn>25</mn></mrow><mn>8</mn></mfrac></mrow></math><span style=\"\" >π-6</span>"
            },
            "difficult": {
              "id": 5,
              "name": "困难"
            },
            "type": {
              "id": 1101,
              "name": "单选题",
              "isSelectType": true
            },
            "updateTime": "2018-09-11T00:22:22",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"\">试题分析：∵菱形ABCD中，AC=8，BD=6，</span><p style=\"\"><span style=\"\">∴AC⊥BD且OA=</span>\n  <math>\n   <mrow>\n    <mfrac>\n     <mn>\n      1\n     </mn>\n     <mn>\n      2\n     </mn>\n    </mfrac>\n   </mrow>\n  </math><span style=\"\">AC=</span>\n  <math>\n   <mrow>\n    <mfrac>\n     <mn>\n      1\n     </mn>\n     <mn>\n      2\n     </mn>\n    </mfrac>\n   </mrow>\n  </math><span style=\"\">×8=4，</span></p><p style=\"\"><span style=\"\">OB=</span>\n  <math>\n   <mrow>\n    <mfrac>\n     <mn>\n      1\n     </mn>\n     <mn>\n      2\n     </mn>\n    </mfrac>\n   </mrow>\n  </math><span style=\"\">BD=</span>\n  <math>\n   <mrow>\n    <mfrac>\n     <mn>\n      1\n     </mn>\n     <mn>\n      2\n     </mn>\n    </mfrac>\n   </mrow>\n  </math><span style=\"\">×6=3，</span></p><p style=\"\"><span style=\"\">由勾股定理得，AB=</span>\n  <math>\n   <mrow>\n    <msqrt>\n     <mrow>\n      <mi>\n       O\n      </mi>\n      <msup>\n       <mi>\n        A\n       </mi>\n       <mn>\n        2\n       </mn>\n      </msup>\n      <mo>\n       +\n      </mo>\n      <mi>\n       O\n      </mi>\n      <msup>\n       <mi>\n        B\n       </mi>\n       <mn>\n        2\n       </mn>\n      </msup>\n     </mrow>\n    </msqrt>\n    <mo>\n     =\n    </mo>\n    <msqrt>\n     <mrow>\n      <msup>\n       <mn>\n        4\n       </mn>\n       <mn>\n        2\n       </mn>\n      </msup>\n      <mo>\n       +\n      </mo>\n      <msup>\n       <mn>\n        3\n       </mn>\n       <mn>\n        2\n       </mn>\n      </msup>\n     </mrow>\n    </msqrt>\n    <mo>\n     =\n    </mo>\n    <mn>\n     5\n    </mn>\n   </mrow>\n  </math><span style=\"\">，</span></p><p style=\"\"><span style=\"\">∴阴影部分的面积=</span>\n  <math>\n   <mrow>\n    <mfrac>\n     <mn>\n      1\n     </mn>\n     <mn>\n      2\n     </mn>\n    </mfrac>\n   </mrow>\n  </math><span style=\"\">•π（</span>\n  <math>\n   <mrow>\n    <mfrac>\n     <mn>\n      5\n     </mn>\n     <mn>\n      2\n     </mn>\n    </mfrac>\n   </mrow>\n  </math><span style=\"\">）</span><sup>2</sup><span style=\"\">-</span>\n  <math>\n   <mrow>\n    <mfrac>\n     <mn>\n      1\n     </mn>\n     <mn>\n      2\n     </mn>\n    </mfrac>\n   </mrow>\n  </math><span style=\"\">×4×3=</span>\n  <math>\n   <mrow>\n    <mfrac>\n     <mrow>\n      <mn>\n       25\n      </mn>\n     </mrow>\n     <mn>\n      8\n     </mn>\n    </mfrac>\n   </mrow>\n  </math><span style=\"\">π-6．</span></p><p style=\"\">故选D．</p><p style=\"\">考点：1．菱形的性质；2．勾股定理．</p><p style=\"line-height: 24px;text-align: left;\"></p></span>"
          },
          {
            "id": 18056029,
            "stem": "<p style='line-height: 24px;'><span style=\"font-family: 宋体;\" >如图，⊙</span><span style=\"font-family: Times New Roman;\" >O</span><span style=\"font-family: 宋体;\" >的直径</span><span style=\"font-family: Times New Roman;\" >BD＝4，</span><span style=\"font-family: 宋体;\" >∠</span><span style=\"font-family: Times New Roman;\" >A＝60°</span><span style=\"font-family: 宋体;\" >，则</span><span style=\"font-family: Times New Roman;\" >CD</span><span style=\"font-family: 宋体;\" >的长度为</span><span class=\"qml-bk\"  index=\"1\" size=\"7\" type=\"underline\" style=\"text-decoration:underline\" >　　　　　　　</span><span style=\"font-family: Times New Roman;\" >．</span></p><p style='line-height: 24px;text-align: left;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/2/2023282421145600/2023821247520768/STEM/a7297411d620499bac78bb22a20204c4.png\" width=\"104\" height=\"100\" /></p>",
            "options": null,
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 1102,
              "name": "填空题",
              "isSelectType": false
            },
            "updateTime": "2018-08-27T00:23:45",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [
              {
                "id": 4505,
                "name": "半圆（直径）所对的圆周角是直角",
                "pathIds": "4030,4474,4475,4501,4505",
                "subjectId": 11
              }
            ],
            "childrenList": [

            ],
            "answer": "<span class=\"qml-an-sq\"><span class=\"qml-an\"><span style=\"font-family: Times New Roman;\" >2</span></span></span>",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >试题解析：</span><math><mrow><mo>∵</mo><mi>B</mi><mi>D</mi></mrow></math><span style=\"font-family: 宋体;\" >为</span><math><mrow><mo>⊙</mo><mi>O</mi></mrow></math><span style=\"font-family: 宋体;\" >的直径，</span><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mo>∠</mo><mi>B</mi><mi>C</mi><mi>D</mi><mo>=</mo><msup><mrow><mn>90</mn></mrow><mo>∘</mo></msup><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >由圆周角定理得</span><span style=\"font-size: 14px;font-family: Times New Roman;\" >,</span><math><mrow><mo>∠</mo><mi>B</mi><mi>D</mi><mi>C</mi><mo>=</mo><mo>∠</mo><mi>A</mi><mo>=</mo><msup><mrow><mn>60</mn></mrow><mo>∘</mo></msup><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >则</span><math><mrow><mi>C</mi><mi>D</mi><mo>=</mo><mi>B</mi><mi>D</mi><mo>×</mo><mtext>cos</mtext><mo>∠</mo><mi>B</mi><mi>D</mi><mi>C</mi><mo>=</mo><mn>4</mn><mo>×</mo><mfrac><mn>1</mn><mn>2</mn></mfrac><mo>=</mo><mn>2.</mn></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >故答案为：</span><math><mrow><mn>2.</mn></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p></span>"
          },
          {
            "id": 18056034,
            "stem": "<p style='line-height: 24px;'><span style=\"font-family: 宋体;\" >圆的半径为</span><span style=\"font-family: Times New Roman;\" >3 cm</span><span style=\"font-family: 宋体;\" >，它的内接正三角形的边长为</span><span class=\"qml-bk\"  index=\"1\" size=\"7\" type=\"underline\" style=\"text-decoration:underline\" >　　　　　　　</span><span style=\"font-family: Times New Roman;\" >cm.</span></p>",
            "options": null,
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 1102,
              "name": "填空题",
              "isSelectType": false
            },
            "updateTime": "2018-09-03T03:16:14",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 6923,
                "name": "22.3 正多边形的有关计算",
                "pathIds": "6918,6922,6923",
                "textbookId": 1389
              },
              {
                "id": 6038,
                "name": "第三节 正多边形与圆",
                "pathIds": "6030,6038",
                "textbookId": 1426
              },
              {
                "id": 6039,
                "name": "27.6 正多边形与圆",
                "pathIds": "6030,6038,6039",
                "textbookId": 1426
              },
              {
                "id": 6165,
                "name": "24.6 正多边形与圆",
                "pathIds": "6159,6165",
                "textbookId": 1378
              },
              {
                "id": 6453,
                "name": "27.4 正多边形和圆",
                "pathIds": "6443,6453",
                "textbookId": 1396
              },
              {
                "id": 6634,
                "name": "29.5 正多边形与圆",
                "pathIds": "6629,6634",
                "textbookId": 1384
              },
              {
                "id": 7141,
                "name": "8 正多边形和圆",
                "pathIds": "7133,7141",
                "textbookId": 1418
              },
              {
                "id": 7306,
                "name": "3.7 正多边形与圆",
                "pathIds": "7299,7306",
                "textbookId": 1401
              },
              {
                "id": 7666,
                "name": "24.3 正多边形和圆",
                "pathIds": "7657,7666",
                "textbookId": 1347
              },
              {
                "id": 7467,
                "name": "31.3 正多边形和圆",
                "pathIds": "7464,7467",
                "textbookId": 1409
              },
              {
                "id": 7831,
                "name": "2.6 正多边形与圆",
                "pathIds": "7825,7831",
                "textbookId": 1365
              },
              {
                "id": 8015,
                "name": "2.7 正多边形与圆",
                "pathIds": "8008,8015",
                "textbookId": 1372
              }
            ],
            "knowledgePoints": [
              {
                "id": 4572,
                "name": "正多边形和圆",
                "pathIds": "4030,4474,4568,4572",
                "subjectId": 11
              }
            ],
            "childrenList": [

            ],
            "answer": "<span class=\"qml-an-sq\"><span class=\"qml-an\"><span style=\"font-family: Times New Roman;\" >3</span><math><mrow><msqrt><mn>3</mn></msqrt></mrow></math></span></span>",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >试题解析：如图所示</span><span style=\"font-size: 14px;font-family: Times New Roman;\" >:</span><p style='line-height: 24px;text-align: left;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2017/11/9/1813407647825920/1814381351362560/EXPLANATION/11d4fa745bbb4dbeab228a1f72cc52cd.png\" width=\"107\" height=\"112\" /></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >在</span><math><mrow><mtext>Rt</mtext><mo>△</mo><mi>B</mi><mi>O</mi><mi>D</mi></mrow></math><span style=\"font-size: 14px;font-family: 宋体;\" >中</span><span style=\"font-size: 14px;font-family: Times New Roman;\" >,</span><math><mrow><mi>O</mi><mi>B</mi><mo>=</mo><mn>3</mn><mo>,</mo><mo>∠</mo><mi>O</mi><mi>B</mi><mi>D</mi><mo>=</mo><msup><mrow><mn>30</mn></mrow><mo>∘</mo></msup><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mi>B</mi><mi>D</mi><mo>=</mo><mtext>cos</mtext><msup><mrow><mn>30</mn></mrow><mo>∘</mo></msup><mo>×</mo><mi>O</mi><mi>B</mi><mo>=</mo><mfrac><mrow><mn>3</mn><msqrt><mn>3</mn></msqrt></mrow><mn>2</mn></mfrac><mo>.</mo></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∵</mo><mi>B</mi><mi>D</mi><mo>=</mo><mi>C</mi><mi>D</mi><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mi>B</mi><mi>C</mi><mo>=</mo><mn>2</mn><mi>B</mi><mi>D</mi><mo>=</mo><mn>3</mn><msqrt><mn>3</mn></msqrt><mo>.</mo></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >故它的内接正三角形的边长为</span><math><mrow><mn>3</mn><msqrt><mn>3</mn></msqrt><mo>.</mo></mrow></math></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >故答案为：</span><math><mrow><mn>3</mn><msqrt><mn>3</mn></msqrt><mo>.</mo></mrow></math></p></span>"
          },
          {
            "id": 18056039,
            "stem": "<p style=''><span style=\"font-family: 宋体;\" >如果⊙O的半径为6 </span><span style=\"font-family: 宋体;font-style: italic;\" >cm</span><span style=\"font-family: 宋体;\" >，OP＝7</span><span style=\"font-family: 宋体;font-style: italic;\" >cm</span><span style=\"font-family: 宋体;\" >，那么点P与⊙O的位置关系是(</span><span style=\"font-family: 宋体;font-style: italic;\" >   </span><span style=\"font-family: 宋体;\" >)</span></p>",
            "options": {
              "A": "<span style=\"\" >点P在⊙O内</span>",
              "B": "<span style=\"\" >点P在⊙O上</span>",
              "C": "<span style=\"\" >点P在⊙O外</span>",
              "D": "<span style=\"\" >不能确定</span>"
            },
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 1101,
              "name": "单选题",
              "isSelectType": true
            },
            "updateTime": "2018-09-03T06:14:18",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 6449,
                "name": "1. 点与圆的位置关系",
                "pathIds": "6443,6448,6449",
                "textbookId": 1396
              },
              {
                "id": 6630,
                "name": "29.1 点与圆的位置关系",
                "pathIds": "6629,6630",
                "textbookId": 1384
              },
              {
                "id": 7664,
                "name": "24.2.1 点和圆的位置关系",
                "pathIds": "7657,7663,7664",
                "textbookId": 1347
              }
            ],
            "knowledgePoints": [
              {
                "id": 4508,
                "name": "点和圆的位置关系",
                "pathIds": "4030,4474,4507,4508",
                "subjectId": 11
              }
            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >试题解析：</span><span style=\"font-family: Times New Roman;\" > </span><span style=\"font-family: 宋体;\" >根据点到圆心的距离</span><math><mrow><mn>7</mn><mtext>cm</mtext></mrow></math><span style=\"font-family: 宋体;\" >大于圆的半径</span><math><mrow><mn>6</mn><mtext>cm</mtext></mrow></math><span style=\"font-family: Times New Roman;\" > </span><span style=\"font-family: 宋体;\" >，则该点在圆外</span><span style=\"font-family: Times New Roman;\" >.</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >故选</span><span style=\"font-family: Times New Roman;\" >C.</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >点睛：根据点到圆心的距离和圆的半径之间的数量关系，即可判断点和圆的位置关系．点到圆心的距离小于圆的半径，则点在圆内；点到圆心的距离等于圆的半径，则点在圆上；点到圆心的距离大于圆的半径，则点在圆外．</span></p></span>"
          },
          {
            "id": 18056043,
            "stem": "<p style=''><span style=\"font-family: 宋体;\" >如图，已知AB是⊙O的直径，PB是⊙O的切线，PA交⊙O于点C，AB＝3 </span><span style=\"font-family: 宋体;font-style: italic;\" >cm</span><span style=\"font-family: 宋体;\" >，PB＝4 </span><span style=\"font-family: 宋体;font-style: italic;\" >cm</span><span style=\"font-family: 宋体;\" >，则BC＝</span><span class=\"qml-bk\"  index=\"1\" size=\"6\" type=\"underline\" style=\"text-decoration:underline\" >　　　　　　</span><span style=\"font-family: 宋体;font-style: italic;\" >cm</span><span style=\"font-family: 宋体;\" >.</span></p><p style=''><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2017/11/9/1813407647825920/1814381351329792/STEM/5f230b044e5346f9a462695b860f7f2a.png\" width=\"140\" height=\"96\" /></p>",
            "options": null,
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 1102,
              "name": "填空题",
              "isSelectType": false
            },
            "updateTime": "2018-08-26T00:31:42",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "<span class=\"qml-an-sq\"><span class=\"qml-an\"><math><mrow><mfrac><mrow><mn>12</mn></mrow><mn>5</mn></mfrac></mrow></math></span></span>",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >试题解析：</span><math><mrow><mo>∵</mo><mi>P</mi><mi>B</mi></mrow></math><span style=\"font-size: 14px;font-family: 宋体;\" >是</span><math><mrow><mo>⊙</mo><mi>O</mi></mrow></math><span style=\"font-size: 14px;font-family: 宋体;\" >的切线，</span><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mo>∠</mo><mi>A</mi><mi>B</mi><mi>P</mi><mo>=</mo><msup><mrow><mn>90</mn></mrow><mo>∘</mo></msup><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∵</mo><mi>A</mi><mi>B</mi><mo>=</mo><mn>3</mn><mtext>cm</mtext><mi>，</mi><mi>P</mi><mi>B</mi><mo>=</mo><mn>4</mn><mtext>cm</mtext><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mi>A</mi><mi>P</mi><mo>=</mo><msqrt><mrow><mi>A</mi><msup><mi>B</mi><mn>2</mn></msup><mo>+</mo><mi>B</mi><msup><mi>P</mi><mn>2</mn></msup></mrow></msqrt><mo>=</mo><msqrt><mrow><msup><mn>3</mn><mn>2</mn></msup><mo>+</mo><msup><mn>4</mn><mn>2</mn></msup></mrow></msqrt><mo>=</mo><mn>5.</mn></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∵</mo><mi>A</mi><mi>B</mi></mrow></math><span style=\"font-size: 14px;font-family: 宋体;\" >是</span><math><mrow><mo>⊙</mo><mi>O</mi></mrow></math><span style=\"font-size: 14px;font-family: 宋体;\" >的直径，</span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mo>∠</mo><mi>A</mi><mi>C</mi><mi>B</mi><mo>=</mo><msup><mrow><mn>90</mn></mrow><mo>∘</mo></msup><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >即</span><math><mrow><mi>B</mi><mi>C</mi></mrow></math><span style=\"font-size: 14px;font-family: 宋体;\" >为</span><math><mrow><mo>△</mo><mi>A</mi><mi>B</mi><mi>P</mi></mrow></math><span style=\"font-size: 14px;font-family: 宋体;\" >的高</span><span style=\"font-size: 14px;font-family: Times New Roman;\" >,</span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∵</mo><mfrac><mn>1</mn><mn>2</mn></mfrac><mo>×</mo><mi>A</mi><mi>B</mi><mo>×</mo><mi>B</mi><mi>P</mi><mo>=</mo><mfrac><mn>1</mn><mn>2</mn></mfrac><mo>×</mo><mi>A</mi><mi>P</mi><mo>×</mo><mi>B</mi><mi>C</mi><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >即</span><math><mrow><mfrac><mn>1</mn><mn>2</mn></mfrac><mo>×</mo><mn>3</mn><mo>×</mo><mn>4</mn><mo>=</mo><mfrac><mn>1</mn><mn>2</mn></mfrac><mo>×</mo><mn>5</mn><mo>×</mo><mi>B</mi><mi>C</mi><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mi>B</mi><mi>C</mi><mo>=</mo><mfrac><mrow><mn>12</mn></mrow><mn>5</mn></mfrac><mo>.</mo></mrow></math><span style=\"font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >故答案为：</span><math><mrow><mfrac><mrow><mn>12</mn></mrow><mn>5</mn></mfrac><mo>.</mo></mrow></math></p></span>"
          },
          {
            "id": 18056045,
            "stem": "<p style='line-height: 24px;'><span style=\"font-family: 宋体;\" >如图，</span><span style=\"font-family: Times New Roman;\" >AB</span><span style=\"font-family: 宋体;\" >是⊙</span><span style=\"font-family: Times New Roman;\" >O</span><span style=\"font-family: 宋体;\" >的直径，经过圆上点</span><span style=\"font-family: Times New Roman;\" >D</span><span style=\"font-family: 宋体;\" >的直线</span><span style=\"font-family: Times New Roman;\" >CD</span><span style=\"font-family: 宋体;\" >恰使∠</span><span style=\"font-family: Times New Roman;\" >ADC＝</span><span style=\"font-family: 宋体;\" >∠</span><span style=\"font-family: Times New Roman;\" >B.</span><span style=\"font-family: 宋体;\" >过点</span><span style=\"font-family: Times New Roman;\" >A</span><span style=\"font-family: 宋体;\" >作直线</span><span style=\"font-family: Times New Roman;\" >AB</span><span style=\"font-family: 宋体;\" >的垂线交</span><span style=\"font-family: Times New Roman;\" >BD</span><span style=\"font-family: 宋体;\" >的延长线于点</span><span style=\"font-family: Times New Roman;\" >E</span><span style=\"font-family: 宋体;\" >，且</span><span style=\"font-family: Times New Roman;\" >AB＝</span><math><mrow><msqrt><mn>5</mn></msqrt></mrow></math><span style=\"font-family: Times New Roman;\" >，BD＝2</span><span style=\"font-family: 宋体;\" >，则线段</span><span style=\"font-family: Times New Roman;\" >AE</span><span style=\"font-family: 宋体;\" >的长为</span><span class=\"qml-bk\"  index=\"1\" size=\"6\" type=\"underline\" style=\"text-decoration:underline\" >　　　　　　</span><span style=\"font-family: Times New Roman;\" >．</span></p><p style='line-height: 24px;text-align: left;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/2/2023282421145600/2023821247545344/STEM/b44e11fb413c441b8b34eaebf9baf2a9.png\" width=\"103\" height=\"108\" /></p>",
            "options": null,
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 1102,
              "name": "填空题",
              "isSelectType": false
            },
            "updateTime": "2018-09-11T00:28:46",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "<span class=\"qml-an-sq\"><span class=\"qml-an\"><math><mrow><mfrac><mrow><msqrt><mn>5</mn></msqrt></mrow><mn>2</mn></mfrac></mrow></math></span></span>",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >试题解析：</span><math><mrow><mo>∵</mo><mi>E</mi><mi>A</mi><mo>⊥</mo><mi>A</mi><mi>B</mi><mo>,</mo></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mo>∠</mo><mi>E</mi><mi>A</mi><mi>B</mi><mo>=</mo><msup><mrow><mn>90</mn></mrow><mo>∘</mo></msup><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mo>∠</mo><mi>B</mi><mo>+</mo><mo>∠</mo><mi>E</mi><mo>=</mo><msup><mrow><mn>90</mn></mrow><mo>∘</mo></msup><mo>.</mo></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∵</mo><mi>A</mi><mi>B</mi></mrow></math><span style=\"font-size: 14px;font-family: 宋体;\" >是</span><math><mrow><mo>⊙</mo><mi>O</mi></mrow></math><span style=\"font-size: 14px;font-family: 宋体;\" >的直径，</span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mo>∠</mo><mi>A</mi><mi>D</mi><mi>B</mi><mo>=</mo><msup><mrow><mn>90</mn></mrow><mo>∘</mo></msup><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mi>A</mi><mi>D</mi><mo>=</mo><msqrt><mrow><mi>A</mi><msup><mi>B</mi><mn>2</mn></msup><mo>−</mo><mi>B</mi><msup><mi>D</mi><mn>2</mn></msup></mrow></msqrt><mo>=</mo><msqrt><mrow><mn>5</mn><mo>−</mo><mn>4</mn></mrow></msqrt><mo>=</mo><mn>1</mn><mo>,</mo></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∠</mo><mi>A</mi><mi>D</mi><mi>B</mi><mo>=</mo><mo>∠</mo><mi>E</mi><mi>A</mi><mi>B</mi><mo>,</mo><mo>∠</mo><mi>B</mi><mo>+</mo><mo>∠</mo><mi>D</mi><mi>A</mi><mi>B</mi><mo>=</mo><msup><mrow><mn>90</mn></mrow><mo>∘</mo></msup><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mo>∠</mo><mi>D</mi><mi>A</mi><mi>B</mi><mo>=</mo><mo>∠</mo><mi>E</mi><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mo>△</mo><mi>A</mi><mi>B</mi><mi>D</mi><mo>∽</mo><mo>△</mo><mi>E</mi><mi>A</mi><mi>D</mi><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mfrac><mrow><mi>A</mi><mi>B</mi></mrow><mrow><mi>A</mi><mi>E</mi></mrow></mfrac><mo>=</mo><mfrac><mrow><mi>B</mi><mi>D</mi></mrow><mrow><mi>A</mi><mi>D</mi></mrow></mfrac><mo>,</mo><mfrac><mrow><msqrt><mn>5</mn></msqrt></mrow><mrow><mi>A</mi><mi>E</mi></mrow></mfrac><mo>=</mo><mfrac><mn>2</mn><mn>1</mn></mfrac><mi>，</mi></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><math><mrow><mo>∴</mo><mi>A</mi><mi>E</mi><mo>=</mo><mfrac><mrow><msqrt><mn>5</mn></msqrt></mrow><mn>2</mn></mfrac><mo>.</mo></mrow></math><span style=\"font-size: 14px;font-family: Times New Roman;\" > </span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >故答案为：</span><math><mrow><mfrac><mrow><msqrt><mn>5</mn></msqrt></mrow><mn>2</mn></mfrac><mo>.</mo></mrow></math></p></span>"
          }
        ]
      };
    },
    name: 'introduce',
    mounted() {
      MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
    },
    methods: {}
  }
</script>
<style scoped>
</style>
<style>

  .paper-example{
    background-color: #ffffff;
    width: 1200px;
    margin: 60px auto;
    box-shadow:0px 5px 10px 0px rgba(0, 0, 0, 0.08);
    padding: 20px;
  }

  .paper-example h1{
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/introduce/history-paper/paper-example-3/index.vue